function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.011 46.2785C35.9387 46.2785 35.8658 46.2575 35.8026 46.2126C35.6411 46.0961 35.6039 45.8729 35.719 45.71C42.6605 35.9919 44.074 21.8949 39.0803 12.1906C35.6054 5.43757 29.4148 1.71871 21.6493 1.71871C21.4508 1.71871 21.29 1.55796 21.29 1.3594C21.29 1.16074 21.4508 1 21.6493 1C29.6977 1 36.1149 4.8575 39.719 11.8618C44.8292 21.7921 43.3933 36.204 36.3036 46.1285C36.2335 46.2266 36.1234 46.2785 36.011 46.2785Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.98161 46.2785C7.8693 46.2785 7.75914 46.2266 7.68897 46.1284C0.444686 35.9877 -1.11249 21.4355 3.98628 11.5276C7.4798 4.73881 13.7527 1 21.6494 1C21.8481 1 22.0088 1.16074 22.0088 1.3594C22.0088 1.55796 21.8481 1.71871 21.6494 1.71871C11.8907 1.71871 7.00531 7.23186 4.62529 11.8565C-0.35722 21.5384 1.17741 35.7758 8.27362 45.71C8.38908 45.8715 8.35152 46.0961 8.19006 46.2126C8.1269 46.2575 8.05394 46.2785 7.98161 46.2785Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.8417 45.4432C34.7694 45.4432 34.6965 45.4222 34.6333 45.3773C34.4719 45.2607 34.4347 45.0376 34.5498 44.8747C41.1965 35.5694 42.5637 22.1009 37.8022 12.8485C35.5268 8.4267 30.8782 3.15605 21.6493 3.15605C21.4508 3.15605 21.29 2.99531 21.29 2.79665C21.29 2.598 21.4508 2.43726 21.6493 2.43726C31.2404 2.43726 36.0749 7.91986 38.4408 12.5195C43.3196 21.9975 41.9284 35.7812 35.1344 45.2929C35.0642 45.3913 34.9541 45.4432 34.8417 45.4432Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.15131 45.4432C9.03899 45.4432 8.92884 45.3913 8.85867 45.293C1.91017 35.5651 0.398361 21.6415 5.26406 12.1853C7.55253 7.73858 12.2529 2.43738 21.6494 2.43738C21.8481 2.43738 22.0088 2.59812 22.0088 2.79678C22.0088 2.99543 21.8481 3.15617 21.6494 3.15617C12.615 3.15617 8.09989 8.24506 5.90343 12.5145C1.15354 21.7445 2.64253 35.3548 9.44323 44.8749C9.55868 45.0377 9.52113 45.2608 9.35967 45.3774C9.29668 45.4222 9.22364 45.4432 9.15131 45.4432Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0111 46.2785C35.9387 46.2785 35.8658 46.2575 35.8026 46.2126L34.6332 45.3773C34.4719 45.2608 34.4347 45.0377 34.5498 44.8748C34.6655 44.7148 34.8908 44.6769 35.0508 44.792L36.2201 45.6272C36.3816 45.7423 36.4195 45.9669 36.3037 46.1284C36.2335 46.2266 36.1234 46.2785 36.0111 46.2785Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.98158 46.2785C7.86927 46.2785 7.75911 46.2266 7.68894 46.1284C7.57348 45.9669 7.61104 45.7423 7.7725 45.6272L8.94216 44.792C9.10362 44.6769 9.32779 44.7148 9.44325 44.8748C9.55871 45.0376 9.52115 45.2608 9.35969 45.3773L8.19012 46.2126C8.12687 46.2575 8.05391 46.2785 7.98158 46.2785Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3889 47C10.8905 47 10.3132 46.809 9.75564 46.1521C9.62679 46.0005 9.64539 45.7745 9.7967 45.6453C9.94755 45.5175 10.1753 45.5358 10.3031 45.686C11.0562 46.5732 11.7412 46.2727 12.2406 46.0539C12.4241 45.9752 12.6347 46.0566 12.714 46.2391C12.7937 46.4203 12.7109 46.6322 12.529 46.7122C12.2824 46.8203 11.8725 47 11.3889 47Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.65305 31.4396C4.56042 31.4396 4.46742 31.4031 4.39725 31.333C4.25789 31.1912 4.25933 30.9638 4.40075 30.8233C4.51342 30.7125 4.64074 30.6142 4.78989 30.5216C4.97732 30.4051 5.16546 30.3209 5.32054 30.2535C5.50303 30.1749 5.71426 30.2563 5.79396 30.4374C5.87401 30.6199 5.79153 30.8319 5.60968 30.9105C5.48092 30.9681 5.3244 31.0355 5.16897 31.1323C5.06582 31.1955 4.97983 31.2629 4.90535 31.3359C4.83553 31.4045 4.74425 31.4396 4.65305 31.4396Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.46648 30.9413C5.32784 30.9413 5.19594 30.8599 5.137 30.7252C5.05731 30.544 5.14015 30.3321 5.32227 30.252L6.63937 29.6765C6.82186 29.5979 7.03345 29.6808 7.11243 29.8618C7.19213 30.043 7.10929 30.2549 6.92716 30.335L5.61006 30.9104C5.56325 30.9315 5.51446 30.9413 5.46648 30.9413Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3852 46.7418C12.2466 46.7418 12.1147 46.6618 12.0557 46.527C11.976 46.3459 12.0589 46.134 12.2406 46.054L13.5556 45.477C13.739 45.3998 13.9496 45.4812 14.029 45.6622C14.1087 45.8434 14.0258 46.0553 13.8441 46.1354L12.5291 46.7122C12.482 46.732 12.4332 46.7418 12.3852 46.7418Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7002 46.1662C13.5616 46.1662 13.4296 46.0862 13.3706 45.9501L6.45402 30.1496C6.37433 29.9671 6.45717 29.7551 6.63902 29.6765C6.82187 29.5979 7.03346 29.6793 7.11244 29.8618L14.029 45.6622C14.1087 45.8447 14.0258 46.0568 13.844 46.1354C13.797 46.1564 13.7482 46.1662 13.7002 46.1662Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7516 33.2434C12.6129 33.2434 12.4809 33.1634 12.422 33.0286C12.3424 32.8462 12.4251 32.6342 12.607 32.5556L13.9237 31.9786C14.1072 31.9015 14.3178 31.9814 14.3972 32.1639C14.4769 32.3463 14.394 32.5583 14.2122 32.637L12.8955 33.2139C12.8484 33.2337 12.7996 33.2434 12.7516 33.2434Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1924 36.5366C14.0538 36.5366 13.9219 36.4565 13.863 36.3204C13.7833 36.1393 13.8661 35.9274 14.0479 35.8473L15.3646 35.2704C15.5475 35.1918 15.7591 35.2746 15.838 35.4557C15.9177 35.6382 15.8349 35.8488 15.653 35.9288L14.3364 36.5058C14.2893 36.5268 14.2405 36.5366 14.1924 36.5366Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6331 39.8284C15.4944 39.8284 15.3625 39.7484 15.3036 39.6136C15.224 39.4311 15.3067 39.2191 15.4885 39.1405L16.806 38.5635C16.9895 38.4849 17.2 38.5663 17.2794 38.7488C17.3591 38.9299 17.2762 39.1418 17.0944 39.2219L15.777 39.7989C15.7299 39.8186 15.6811 39.8284 15.6331 39.8284Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1817 45.2551C14.7146 45.2551 14.2482 45.1542 13.8155 44.952C13.6355 44.8692 13.5575 44.6544 13.6414 44.4747C13.7246 44.2964 13.9372 44.2164 14.1187 44.3006C14.7724 44.6052 15.5283 44.6135 16.1899 44.3258C17.4599 43.7685 18.0411 42.2819 17.4853 41.0116L12.8744 30.4765C12.317 29.2048 10.8308 28.6264 9.56083 29.1823C8.89971 29.4715 8.39395 30.0315 8.17328 30.7208C8.11326 30.9102 7.91182 31.0113 7.72161 30.9538C7.53248 30.892 7.42825 30.6899 7.48899 30.5019C7.77255 29.6161 8.42243 28.8946 9.27277 28.5239C10.9056 27.8067 12.8165 28.5562 13.5328 30.1888L18.1437 40.7238C18.8585 42.3563 18.1114 44.2682 16.4781 44.9842C16.0647 45.164 15.6228 45.2551 15.1817 45.2551Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M32.6295 47C32.1458 47 31.736 46.8203 31.489 46.7122C31.3073 46.6323 31.2244 46.4203 31.3044 46.2392C31.3837 46.0568 31.5943 45.9739 31.7775 46.0539C32.2778 46.2729 32.9637 46.5732 33.7146 45.6875C33.8431 45.5358 34.0698 45.5163 34.2215 45.6454C34.3731 45.7745 34.3914 46.0005 34.2629 46.1521C33.7054 46.8091 33.1277 47 32.6295 47Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M39.3653 31.4396C39.274 31.4396 39.1829 31.4045 39.1127 31.3358C39.0383 31.2629 38.9519 31.1955 38.8494 31.1322C38.6949 31.0368 38.5391 30.968 38.4114 30.9118L38.6971 30.2521L38.5525 30.582L38.7006 30.2549C38.8551 30.3222 39.0418 30.4051 39.2284 30.5202C39.3779 30.6143 39.5049 30.7126 39.6172 30.8233C39.759 30.9637 39.7605 31.1912 39.6207 31.333C39.5507 31.4031 39.458 31.4396 39.3653 31.4396Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M38.5518 30.9413C38.5041 30.9413 38.455 30.9315 38.4079 30.9104L37.0912 30.3349C36.9095 30.2549 36.8266 30.0429 36.9066 29.8618C36.9852 29.6794 37.1965 29.5966 37.3797 29.6765L38.6964 30.252C38.8781 30.3321 38.961 30.544 38.8816 30.7252C38.8227 30.8613 38.6907 30.9413 38.5518 30.9413Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M31.6328 46.7417C31.5851 46.7417 31.536 46.7319 31.4889 46.7122L30.1743 46.1354C29.9926 46.0553 29.9097 45.8434 29.9897 45.6622C30.0697 45.4798 30.2802 45.3983 30.4628 45.477L31.7774 46.054C31.9591 46.134 32.042 46.3459 31.9626 46.527C31.9031 46.6618 31.7718 46.7417 31.6328 46.7417Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M30.3182 46.1662C30.2705 46.1662 30.2213 46.1564 30.1743 46.1354C29.9926 46.0568 29.9097 45.8448 29.9897 45.6623L36.9065 29.8618C36.9851 29.6794 37.1964 29.5966 37.3796 29.6765C37.5614 29.7551 37.6442 29.967 37.5649 30.1496L30.6479 45.95C30.5892 46.0863 30.4572 46.1662 30.3182 46.1662Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2665 33.2435C31.2188 33.2435 31.1697 33.2337 31.1226 33.214L29.8059 32.6371C29.6242 32.5584 29.5413 32.3465 29.6213 32.164C29.7006 31.9815 29.9112 31.9 30.0944 31.9787L31.4111 32.5557C31.5928 32.6343 31.6756 32.8462 31.5964 33.0287C31.5374 33.1634 31.4054 33.2435 31.2665 33.2435Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M29.8262 36.5366C29.7785 36.5366 29.7294 36.5269 29.6823 36.5057L28.3656 35.9288C28.1839 35.8488 28.101 35.6382 28.181 35.4557C28.2603 35.2733 28.4709 35.1904 28.6541 35.2704L29.9708 35.8473C30.1525 35.9274 30.2353 36.1392 30.1561 36.3204C30.0971 36.4567 29.9652 36.5366 29.8262 36.5366Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3853 39.8284C28.3376 39.8284 28.2884 39.8186 28.2414 39.7989L26.924 39.2219C26.7422 39.1419 26.6594 38.93 26.7393 38.7489C26.8187 38.5664 27.0285 38.4835 27.2124 38.5636L28.5298 39.1405C28.7115 39.2191 28.7944 39.4311 28.715 39.6137C28.6562 39.7484 28.5242 39.8284 28.3853 39.8284Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8366 45.2551C28.3952 45.2551 27.9537 45.1639 27.5409 44.9842C25.9077 44.2683 25.1602 42.3578 25.8747 40.7238L30.486 30.1888C31.2019 28.5548 33.113 27.8066 34.7463 28.524C35.5962 28.8961 36.2461 29.6161 36.5291 30.5019C36.5902 30.6901 36.4856 30.8935 36.2967 30.9539C36.1059 31.0115 35.9052 30.909 35.8448 30.7209C35.6244 30.0316 35.1191 29.4715 34.4586 29.1824C33.1881 28.6264 31.7009 29.2063 31.1443 30.478L26.5331 41.0116C25.9779 42.282 26.559 43.7686 27.8287 44.3259C28.4906 44.615 29.2457 44.6052 29.9 44.3006C30.0803 44.2164 30.2937 44.2964 30.3773 44.4748C30.4608 44.6544 30.3828 44.8692 30.2031 44.9521C29.7701 45.1541 29.3033 45.2551 28.8366 45.2551Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8441 13.701C36.6926 13.701 36.5515 13.6045 36.5024 13.4529C36.4405 13.264 36.5445 13.0612 36.7325 12.9998L38.2177 12.5169C38.4078 12.4562 38.6092 12.559 38.671 12.7475C38.7321 12.9363 38.6289 13.1391 38.4401 13.2005L36.955 13.6834C36.9178 13.6954 36.8806 13.701 36.8441 13.701Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8443 13.701C36.7138 13.701 36.5881 13.6301 36.5242 13.5062C34.432 9.44023 30.1534 4.59349 21.6495 4.59349C21.4509 4.59349 21.2902 4.43275 21.2902 4.23409C21.2902 4.03544 21.4509 3.87469 21.6495 3.87469C30.5155 3.87469 34.9801 8.93339 37.1636 13.1769C37.2541 13.3534 37.1846 13.5703 37.0084 13.6613C36.9558 13.6883 36.8997 13.701 36.8443 13.701Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M6.45508 13.7019C6.39965 13.7019 6.34349 13.6892 6.29084 13.6622C6.11473 13.5713 6.04528 13.3544 6.13576 13.1779C8.31964 8.93437 12.7839 3.87567 21.6495 3.87567C21.8482 3.87567 22.0089 4.03641 22.0089 4.23507C22.0089 4.43373 21.8482 4.59447 21.6495 4.59447C13.1464 4.59447 8.86745 9.44121 6.77522 13.5072C6.71133 13.6306 6.58564 13.7019 6.45508 13.7019Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M6.45504 13.701C6.4031 13.701 6.35009 13.6898 6.29987 13.6655L5.2931 13.1826C5.11412 13.097 5.03865 12.8822 5.12464 12.7032C5.21062 12.5246 5.42464 12.4484 5.60398 12.5348L6.61084 13.0177C6.78981 13.1033 6.86529 13.3181 6.7793 13.4971C6.71758 13.6259 6.58909 13.701 6.45504 13.701Z",
  fill: "#D8896E",
  stroke: "#D8896E",
  strokeWidth: 0.1
});
const SvgIcon5 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 43,
  height: 48,
  viewBox: "0 0 43 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon5, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon5.4a4da916.svg";
export { ForwardRef as ReactComponent };